@if (report(); as report) {
  <h2 class="relative px-[30px] text-center !font-bold mb-3">
    Wallet Report
  </h2>
  <div class="bg-[#B3C0C22B] px-2 pb-[10px] rounded-lg mb-3">
    <p class="flex justify-between items-center min-h-[24px] !mb-0 text-[12px] border-b border-solid border-[#E5E5E5]">
      <span>Report ID</span>
      <span>{{ report.id }}</span>
    </p>
    <p class="flex justify-between items-center min-h-[24px] !mb-1 text-[12px]">
      <span>Report Time</span>
      <span>{{ report.createdDate | date: 'h:mm a, dd/MM/yy' }}</span>
    </p>

    @if (walletRental(); as walletRental) {
      @if (walletRental && (walletRental.status === 'AWAITING_PAYMENT' || walletRental.status === 'EXPIRED' || walletRental.status === 'EXPIRED_BY_TIME' || walletRental.type === 'TRIAL_EXPIRED' || (walletRental.incomingLeft < 1 && walletRental.outcomingLeft < 1))) {
        <div class="flex -mx-2 bg-white rounded-[6px] shadow-1 border border-solid border-[#C93535] mb-2">
          <div class="flex py-[10px] pl-2 pr-[10px] w-[96px] border-r border-solid border-[#022D35]">
            <div class="mr-2 flex items-center justify-center">
              <mat-icon class="!min-w-[30px] !w-[30px] !h-[30px]" [svgIcon]="'circle-usdt'"></mat-icon>
            </div>
            <div class="min-w-[38px] flex flex-col">
              <span class="leading-[1.2] font-bold mb-1">USDT</span>
              <span class="leading-[1.2] text-[11px]">TRC-20</span>
            </div>
          </div>
          <div class="flex justify-between py-2 pl-[10px] pr-2 w-calc-96">
            <div class="flex flex-col justify-center w-full">
              <span class="leading-[1.2] text-[#C93535] text-[12px] mb-[2px] flex items-center justify-between">
                <span [ngClass]="currentLang === 'ru' ? 'text-[11px]' : 'text-[12px]'">TRC20 wallet address:</span>
                <span class="flex items-center bg-[#C93535] text-white text-[10px] rounded-[29px] py-[3px]"
                      [ngClass]="currentLang === 'ru' ? 'px-[3px]' : 'px-[7px]'">AML Monitoring Off</span>
              </span>
              <span class="leading-[1.2] text-[#C93535] ">{{ report.address | cropWithDotsCenter }}</span>
            </div>
          </div>
        </div>
      } @else {
        <ng-container [ngTemplateOutlet]="isSubscribed"></ng-container>
      }
    } @else {
      <ng-container [ngTemplateOutlet]="isSubscribed"></ng-container>
    }


    <ng-template #isSubscribed>
      <div class="flex -mx-2 bg-white rounded-[6px] shadow-1 border border-solid border-[#022D35] mb-2">
        <div class="flex py-[10px] pl-2 pr-[10px] w-[96px] border-r border-solid border-[#022D35]">
          <div class="mr-2 flex items-center justify-center">
            <mat-icon class="!min-w-[30px] !w-[30px] !h-[30px]" [svgIcon]="'circle-usdt'"></mat-icon>
          </div>
          <div class="min-w-[38px] flex flex-col">
            <span class="leading-[1.2] font-bold mb-1">USDT</span>
            <span class="leading-[1.2] text-[11px]">TRC-20</span>
          </div>
        </div>
        <div class="flex justify-between py-2 pl-[10px] pr-2 w-calc-96">
          <div class="flex flex-col justify-center w-full">
            <span class="leading-[1.2] text-[#94A3A6] text-[12px] mb-[2px]">TRC20 wallet address:</span>
            <span class="leading-[1.2] text-[#94A3A6] ">{{ report.address | cropWithDotsCenter }}</span>
          </div>
          <div class="flex items-center">
            <mat-icon class="!w-[19px] !h-[23px]" [svgIcon]="'shield'"></mat-icon>
          </div>
        </div>
      </div>
    </ng-template>

    <a target="_blank" href="https://t.me/AMLOfficer_support_bot"
       class="flex justify-between items-center rounded-[6px] min-h-[25px] px-3 py-1 mb-2"
       [ngClass]="report.data.registeredAddressRiskResponse.risk === 'MEDIUM' ? '' : 'text-white'"
       [class.bg-[#C92F29]]="report.data.registeredAddressRiskResponse.risk === 'SEVERE'"
       [class.bg-[#EA3D3D]]="report.data.registeredAddressRiskResponse.risk === 'HIGH'"
       [class.bg-[#FFCB10]]="report.data.registeredAddressRiskResponse.risk === 'MEDIUM'"
       [class.bg-[#87C05A]]="report.data.registeredAddressRiskResponse.risk === 'LOW'"
    >
      <div class="flex items-center">
        <div class="mr-[10px]">
          @switch (report.data.registeredAddressRiskResponse.risk) {
            @case ('SEVERE') {
              <img [ngSrc]="'assets/icons/icon-risk-severe.svg'" alt="risk" height="14" width="14">
            }
            @case ('HIGH') {
              <img [ngSrc]="'assets/icons/icon-risk-high.svg'" alt="risk" height="14" width="6">
            }
            @case ('MEDIUM') {
              <img [ngSrc]="'assets/icons/icon-risk-medium.svg'" alt="risk" height="14" width="6">
            }
            @case ('LOW') {
              <img [ngSrc]="'assets/icons/icon-risk-low.svg'" alt="risk" height="12" width="12">
            }
          }
        </div>
        <span class="leading-[1.2] text-[13px]">
          @switch (report.data.registeredAddressRiskResponse.risk) {
            @case ('SEVERE') {
              Severe Risk
            }
            @case ('HIGH') {
              High Risk
            }
            @case ('MEDIUM') {
              Medium Risk
            }
            @case ('LOW') {
              Low Risk
            }
          }
        </span>
      </div>
      <div class="flex">
        <span class="leading-[1.2] text-[11px]">
          Ask Compliance →
        </span>
      </div>
    </a>
    @if (report.data.registeredAddressRiskResponse.riskReason) {
      <div class="flex flex-col p-2 border border-solid border-[#022D35] rounded-[6px]">
        <span class="mb-1">Risk reason:</span>
        <span
          class="text-[#45525B] opacity-50 leading-[1.3]">{{ report.data.registeredAddressRiskResponse.riskReason }}</span>
      </div>
    }
    <!-- TODO: Не удалять, будет использоваться позже -->
    <!--      @if (walletRental(); as walletRental) {-->
    <!--        @if (walletRental && (walletRental.status === 'AWAITING_PAYMENT' || walletRental.status === 'EXPIRED' || walletRental.status === 'EXPIRED_BY_TIME' || walletRental.type === 'TRIAL_EXPIRED' || (walletRental.incomingLeft < 1 && walletRental.outcomingLeft < 1))) {-->
    <!--          <app-report-cost-subscribe class="block mt-3" [walletRental]="walletRental" [typeReport]="report.process"></app-report-cost-subscribe>-->
    <!--        }-->
    <!--      }-->

  </div>

  <div>
    @if (report.data.registeredAddressRiskResponse; as riskResponse) {
      <mat-tab-group class="report-tabs" animationDuration="0ms">
        @if (riskResponse.exposures && riskResponse.exposures.length > 0) {
          <mat-tab [label]="('Sources') + ' (' + riskResponse.exposures.length + ')'">
            <app-report-exposures class="block mt-3" [exposures]="riskResponse.exposures"
                                  [typeReport]="report.process"></app-report-exposures>
          </mat-tab>
        }
        @if (riskResponse.triggers && riskResponse.triggers.length > 0) {
          <mat-tab [label]="('Triggers') + ' (' + riskResponse.triggers.length + ')'">
            <app-report-triggers class="block mt-3" [riskResponse]="riskResponse"
                                 [typeReport]="report.process"></app-report-triggers>
          </mat-tab>
        }
        @if (riskResponse.cluster || (riskResponse.addressIdentifications && riskResponse.addressIdentifications.length > 0)) {
          <mat-tab [label]="'Important'">
            @if (riskResponse.cluster && riskResponse.addressIdentifications && riskResponse.addressIdentifications.length > 0) {
              <app-report-identification class="block mt-3" [typeReport]="report.process"
                                         [info]="{name: riskResponse.cluster.name, category: riskResponse.cluster.category, description: riskResponse.addressIdentifications[0].description}"></app-report-identification>
            } @else if (riskResponse.cluster) {
              <app-report-identification class="block mt-3" [typeReport]="report.process"
                                         [info]="{name: riskResponse.cluster.name, category: riskResponse.cluster.category, description: ''}"></app-report-identification>
            } @else {
              @if (riskResponse.addressIdentifications; as addressIdentifications) {
                @if (addressIdentifications.length > 0) {
                  <app-report-identification class="block mt-3" [typeReport]="report.process"
                                             [info]="{name: addressIdentifications[0].name, category: addressIdentifications[0].category, description: addressIdentifications[0].description}"></app-report-identification>
                }
              }
            }
          </mat-tab>
        }
      </mat-tab-group>
    }
  </div>

} @else {
  No data
}
